import React from 'react';
export function PainSection() {
  return <section className="bg-[#0a1128] py-4 md:py-6 px-3 border-y border-[#1e293b]" data-id="element-88">
      <div className="max-w-2xl mx-auto" data-id="element-89">
        <h2 className="text-2xl md:text-3xl font-black text-white mb-3 text-center" data-id="element-90">
          Si enseñás teclado, esto te pasa.
        </h2>

        <div className="bg-[#050a1a] border border-[#1e293b] rounded-xl p-4 shadow-2xl" data-id="element-91">
          <p className="text-sm md:text-base text-gray-300 mb-2 leading-relaxed" data-id="element-92">
            Terminás tu día… y cuando podrías cortar, tenés que ponerte a armar
            clases. Buscás ejercicios. Pensás qué canción dar. Intentás ordenar
            contenido que nunca termina de cerrar.
          </p>

          <p className="text-base md:text-lg font-bold text-white mb-3" data-id="element-93">
            Y al final…{' '}
            <span className="text-[#ef4444]" data-id="element-94">👉 Terminás improvisando.</span>
          </p>

          <div className="space-y-1.5 mb-3" data-id="element-95">
            {['No tenés una estructura clara', 'Perdés horas todas las semanas', 'Repetís contenido', 'No sabés si el alumno realmente avanza'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#0f172a] p-2 rounded-lg border border-[#1e293b]" data-id="element-96">
                <span className="text-[#ef4444] text-sm" data-id="element-97">❌</span>
                <span className="text-gray-200 font-medium text-sm" data-id="element-98">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-sm text-gray-300 mb-3" data-id="element-99">
            Y eso no solo te consume tiempo…
            <span className="text-[#eab308] font-bold text-base block mt-1" data-id="element-100">
              👉 Te hace enseñar por debajo de tu nivel.
            </span>
          </p>

          <div className="bg-[#2563eb]/10 border border-[#2563eb]/30 rounded-lg p-3 text-center" data-id="element-101">
            <p className="text-base md:text-lg font-black text-white text-glow-blue" data-id="element-102">
              ¿Cuántos fines de semana más vas a seguir perdiendo por no tener
              todo listo?
            </p>
          </div>
        </div>
      </div>
    </section>;
}